export const constants = {
	selector: {
		conditionsBuilderComponent: '.js-conditions-builder-component',
		fetchDataEndpoint: 'data-source-field-handler',
		saveHandler: 'data-save-conditions',
		questionnaireId: 'data-questionnaire-id',
		conditionsName: 'data-conditions-name',
		global: 'data-global',
	},
	translations: {
		getSql: 'translation-get-sql',
		saveConditions: 'translation-save-conditions',
		globalLabel: 'translation-global-label',
	},
}
